import styled from "styled-components";

export const TodoWrap = styled.div`
max-width: 260px
`
export const TodoInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
`